module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("erpKS"))).then(() => parcelRequire('5erN3'));